export default function Statistics() {
  const stats = [
    { number: '500+', label: 'Happy Clients', icon: 'ri-user-smile-line' },
    { number: '15', label: 'Years Experience', icon: 'ri-award-line' },
    { number: '100%', label: 'Satisfaction', icon: 'ri-thumb-up-line' }
  ];

  return (
    <section className="py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-2xl mx-auto mb-4">
                <i className={`${stat.icon} text-3xl text-white`}></i>
              </div>
              <div className="text-5xl font-bold text-teal-500 mb-2 font-['Poppins']">
                {stat.number}
              </div>
              <div className="text-sm uppercase tracking-wider text-slate-600 font-semibold">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
